/**
 * 用电结算模块
 */
import request from "@/utils/request.js";

export const getDeviceInfo = () => {
  return request({
    url: "/api/power/getDeviceInfo",
    methods: "GET",
  });
};

// 用电明细
export const getPowerLine = (params) => {
  return request({
    url: "/api/power/getPowerLine",
    methods: "GET",
    params,
  });
};

// 确认缴费
export const getConfirmpay = (params) => {
  return request({
    url: `/settlement/verify/${params}`,
    methods: "GET",
  });
};

// 获取数据
export const getBillData = (params) => {
  return request({
    url: `/settlement/bill?type=${params.type}&dateMonth=${params.dateMonth}`,
    methods: "GET",
  });
};

// 获取数据
export const getBillData2 = (dateMonth) => {
  return request({
    url: `/settle/settleBill?dateMonth=${dateMonth}`,
    methods: "GET",
  });
};

